import { baseUrl, headers, jwtHeaders, logoutUtil } from "../common/data";

export const fetchAllClients = async ({ limit }) => {
    const response = await fetch(`${baseUrl}/api/client/getallclients?limit=${limit}`, {
        method: "GET",
        headers: jwtHeaders(),
        redirect: "follow",
    });
   
    if (response?.status === 401) {
        logoutUtil();
    }
    const resData = await response?.json();
   
    return resData;
};

export const createClient = async (data) => {
    try {
        const response = await fetch(`${baseUrl}/api/client/create`, {
            method: 'POST',
            body: data,
            headers: headers
        })
        const resData = await response?.json();
       
        return resData;
    } catch (err) { }
};

export const deleteClient = async (data) => {
    try {
        const response = await fetch(`${baseUrl}/api/client/deleteclient/${data}`, {
            method: 'DELETE',
            headers: headers,
        })
        const resData = await response?.json();
       
        return resData;
    } catch (err) { }
};